"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.updateProfileCommand = void 0;var _command = require("./command");




/**
 * method that updates the profile of the current user
 * @param id - command ID
 * @param config
 * @param state
 * @param user
 * @param encodedClientState - encoded client state - will be returned in response
 */
const updateProfileCommand = (id, config, state, user, encodedClientState) => {
  //(temporarily) don't allow email update
  delete user.email;

  config.authenticationFrame.contentWindow.postMessage(
    new _command.Command(config.clientType, _command.Command.Commands.updateProfile, {
      id,
      user,
      authentication: state.currentAuthentication,
      clientState: encodedClientState
    }),
    '*'
  );
};exports.updateProfileCommand = updateProfileCommand;